export default function getDFPBlock(slotId, slotSize, advPlace, advPlaceWidth, callback, fallback) {
    let advWrapper = document.getElementById(advPlace);
   /* let adlCont = advWrapper.getAttribute('adlcont') === 'false' ? '' : 'adult24';*/

    advWrapper.style.margin = '0 auto';
    if(typeof advPlaceWidth != 'undefined'){
        advWrapper.style.width = advPlaceWidth;
    }

    if (typeof googletag === 'undefined') {
        window.googletag = window.googletag || {};
        window.googletag.cmd = window.googletag.cmd || [];
        let gads = document.createElement('script');
        gads.async = true;
        gads.type = 'text/javascript';
        gads.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
        let node = document.getElementsByTagName('script')[0];
        node.parentNode.insertBefore(gads, node);
    }

    googletag.cmd.push(function () {
        let slot = googletag.defineSlot(slotId, slotSize, advPlace)
            .addService(googletag.pubads())
            // .setTargeting('ContType', adlCont)
            .setTargeting('siteName', dfpTargetingInfinite.siteName);

        googletag.pubads().enableSingleRequest();
        googletag.enableServices();
        googletag.display(slot);


        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
            if (slot === event.slot) {
                if (!event.isEmpty) {
                    if (typeof callback !== 'undefined') {
                        callback(event);
                    }
                } else if (typeof fallback !== 'undefined') {
                    getDFPBlock(fallback.id, fallback.size, fallback.wrapper);
                    fallback = undefined;
                } else {

                    //get native adv name from advPlace:  adv1454411100_left, adv1454411100_right
                    if(advPlace.includes('_')) {
                        document.getElementById(advPlace.substring(0,advPlace.indexOf('_'))).style.display = 'none';
                    }

                    advWrapper.style.display = 'none';
                }
            }
        });
    });
}